"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isConstantReference = isConstantReference;
exports.isVariableConfig = isVariableConfig;
exports.isVariableReference = isVariableReference;
exports.isVarsParameter = isVarsParameter;
function isConstantReference(param) {
  return (param === null || param === void 0 ? void 0 : param.type) === "const";
}
function isVariableReference(param) {
  return (param === null || param === void 0 ? void 0 : param.type) === "var";
}
function isVarsParameter(val) {
  if (val && val.type && typeof val.type === "string") {
    let keys = Object.keys(val);
    if (val.param && keys.length === 2) {
      return true;
    }
    if (keys.length === 1) {
      return true;
    }
  }
  return false;
}
function isVariableConfig(param) {
  return typeof param === "object" && "name" in param;
}
//# sourceMappingURL=util.js.map